import { useQuery } from '@tanstack/react-query';
import { getInstagramMediaByIds } from '@/services/instagram.service';
import { queryKeys } from '@/hooks/queries/keys';

const MAX_IDS = 50;

export const useInstagramMediaByIds = (ids: string[], options?: { enabled?: boolean }) => {
    const tooMany = ids.length > MAX_IDS;
    if (tooMany && typeof console !== 'undefined') {
        console.warn(`[useInstagramMediaByIds] ids 길이 ${ids.length} > ${MAX_IDS}. 호출이 비활성화됩니다.`);
    }

    const enabled = (options?.enabled ?? true) && ids.length > 0 && !tooMany;

    return useQuery({
        queryKey: queryKeys.instagram.mediaByIds(ids),
        queryFn: () => getInstagramMediaByIds(ids),
        enabled,
        staleTime: 1000 * 60,
    });
};
